import { formatReviewCount } from '@/entities/doctor';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { formatPriceComma } from '@/utils/format';
export interface TelemedicinePageQueries {
  type: ECategoryType;
  id: string;
  page?: string;
}

export enum EDoctorSortType {
  DEFAULT = 'DEFAULT',
  DISTANCE = 'DISTANCE',
  REVIEW_COUNT = 'REVIEW_COUNT',
  REVIEW_AVERAGE_RATING = 'REVIEW_AVERAGE_RATING',
}

export enum EBookingAvailability {
  NotBookable = 'NOT_BOOKABLE',
  TodayBookable = 'TODAY_BOOKABLE',
  TomorrowBookable = 'TOMORROW_BOOKABLE',
  UpcomingBookable = 'UPCOMING_BOOKABLE',
  Unknown = 'UNKNOWN',
}

export enum EBookingScheduleType {
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
}

export class NonF2fDoctorReviewInfo {
  constructor(
    public averageRating: number,
    public count: number
  ) {}

  get reviewCountText(): string {
    return `${formatReviewCount(this.count)}`;
  }

  get reviewAverageText(): string {
    return `${this.averageRating.toFixed(1)}`;
  }

  get isReviewAverageRatingOverZero(): boolean {
    return Number(this.averageRating) > 0;
  }
}

export class NonF2fBookingSchedule {
  constructor(
    public isBookable: boolean,
    public schedule: string,
    private scheduleType: EBookingScheduleType
  ) {}
  get isTodayBookable(): boolean {
    return this.scheduleType === EBookingScheduleType.Today;
  }

  get scheduleTypeText(): string {
    if (this.scheduleType === EBookingScheduleType.Today) {
      return '오늘 예약';
    }
    return '내일 예약';
  }
}

export class NonF2fBookingInfo {
  constructor(
    private bookingAvailability: EBookingAvailability,
    private schedules: NonF2fBookingSchedule[]
  ) {}
  get isBookingAvailable(): boolean {
    return this.bookingAvailability !== EBookingAvailability.NotBookable;
  }

  get closestSchedule(): NonF2fBookingSchedule | null {
    return this.schedules.find((schedule) => schedule.isBookable) || null;
  }
}

export interface TreatmentMedicineUnit {
  unitDisplayName: string;
  unitTypeDisplayName: string;
}

export class NonF2fDoctorMedicinePricing {
  constructor(
    public treatmentMedicineName: string,
    public doctorTreatmentMedicineUnitPricingId: string,
    public originalPrice: number,
    public priceOnUsingPoint: number,
    public unit: TreatmentMedicineUnit
  ) {}

  get medicinePriceDisplayPrice() {
    return formatPriceComma(this.priceOnUsingPoint);
  }
}

export class NonF2fDoctor {
  constructor(
    public hospitalName: string,
    public doctorPublicId: string,
    public doctorName: string,
    public medicineType: string,
    private _profileUrl: string | null,
    public readyForVideoCall: boolean,
    public professionalDepartmentName: string | null,
    public review: NonF2fDoctorReviewInfo,
    public bookingInfo: NonF2fBookingInfo | null,
    public medicinePricing: NonF2fDoctorMedicinePricing | null
  ) {}
  get medicineTypeText(): string {
    if (this.medicineType === 'oriental_doctor') {
      return '한의사';
    }
    return '의사';
  }

  get doctorNameFullText(): string {
    return `${this.doctorName} ${this.medicineTypeText}`;
  }

  get profileUrl(): string | null {
    if (!this._profileUrl || this._profileUrl.includes('null')) {
      return null;
    }
    return this._profileUrl;
  }
}
